'use client';

import { CatButton } from 'components/blocks-components';
import styles from './style.module.scss';
import { bannerTexts } from '../../constants';
import { USER_RESET_SESSION } from 'constants/endpoints.api';
import { Method } from 'constants/enums';

export const BobBanner = ({ fullName }) => {
  const disconnect = async () => {
    const response = await fetch(USER_RESET_SESSION, {
      method: Method.GET
    });
    const data = await response.json();
    window.location.href = data.url;
  };

  const redirectToCSRHome = () => {
    disconnect();
  };

  const { LOGGED_IN_AS, DISCONNECT_BTN } = bannerTexts;

  return (
    <header className={styles['header']}>
      <div className="d-flex justify-content-center align-items-center">
        <p className="mt-2 mb-2">{`${LOGGED_IN_AS} ${fullName}`}</p>
        <CatButton
          className="p-2"
          variant="contrast"
          inverted
          onClick={redirectToCSRHome}
        >
          {DISCONNECT_BTN}
        </CatButton>
      </div>
    </header>
  );
};
